module.exports = __webpack_public_path__ + "img/v7.44c32814.png";